import { render, staticRenderFns } from "./campusButton.vue?vue&type=template&id=e52da574&scoped=true&lang=true&"
import script from "./campusButton.vue?vue&type=script&lang=js&"
export * from "./campusButton.vue?vue&type=script&lang=js&"
import style0 from "./campusButton.vue?vue&type=style&index=0&id=e52da574&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e52da574",
  null
  
)

export default component.exports